import React from "react";
import "./ModelWaitingDisplay.scss";

const ModelWaitingDisplay = (props) => {
  return (
        <div className="spinner"></div>
  );
};

export default ModelWaitingDisplay;
